/**
 * Radio 1 Cricket League Simulator
 * A fictional cricket league that runs continuously - everyone watches the same match
 */

// ============================================
// TEAMS & PLAYERS
// ============================================

const teams = [
  {
    id: 'breakfast-bashers',
    name: 'Breakfast Bashers',
    shortName: 'BRK',
    color: '#FF6B35',
    // Greg James Breakfast Show
    players: ['Leg James', 'Sweep-ney', 'Chris Smi-th-ird Man', 'Bowled Adele', 'Cover-t Operator', 'Silly Mid-Mornin\'', 'Caught Behind Schedule', 'Early Innings', 'The Night Watchman', 'Stumps O\'Clock', 'All-Rounder Toast']
  },
  {
    id: 'rmc-allstars',
    name: 'RMC Allstars',
    shortName: 'RMC',
    color: '#4ECDC4',
    // Rickie, Melvin and Charlie
    players: ['Rickie Boundaries', 'Melvin\' It', 'Caught & Charlie', 'Mid-Morning Maiden', 'Spin King Rickie', 'Mel-Sweep', 'Charlie\'s Yorker', 'The Big Hit Trio', 'Run Rate Rickie', 'Melvin Overthrows', 'Charlie\'s Covers']
  },
  {
    id: 'going-home-xi',
    name: 'Going Home XI',
    shortName: 'GHX',
    color: '#9B59B6',
    // Going Home with Katie and Jamie
    players: ['Katie Pace', 'Jamie\'s Jammers', 'Drive Time Dive', 'Rush Hour Run Out', 'Commuter Cover', 'Traffic Jam Throw', 'Home Run Katie', 'Jamie\'s Jaffa', 'Motorway Mid-Off', 'Lane Change LBW', 'Hard Shoulder Hit']
  },
  {
    id: 'hottest-records',
    name: 'Hottest Records',
    shortName: 'HOT',
    color: '#E74C3C',
    // Radio 1's New Music Show with Jack Saunders
    players: ['Slog Saunders', 'Jack Boundaries', 'Hottest Record Holder', 'New Music Nightwatchman', 'Premier Pace', 'First Play First Slip', 'World Exclusive Wicket', 'Debut Dan', 'Fresh Spin Fred', 'Jack\'s Jaffa', 'New Entry Nigel']
  },
  {
    id: 'chart-toppers',
    name: 'Chart Toppers',
    shortName: 'CTP',
    color: '#F39C12',
    // The Official Chart with Jack Saunders
    players: ['Number One-dred', 'Top Forty-Four', 'New Entry Eleven', 'Non-Mover Nigel', 'Climber Chris', 'Chart Run Chase', 'Re-Entry Rita', 'Highest New Hit', 'Midweek Flash', 'Jack\'s Chart Attack', 'Faller Fred']
  },
  {
    id: 'future-pop-xi',
    name: 'Future Pop XI',
    shortName: 'FPX',
    color: '#FF69B4',
    // Radio 1's Future Pop with Mollie King
    players: ['Bowl-ie King', 'Mollie\'s Maiden Over', 'King Pair Mollie', 'Pop Fly Catch', 'Rising Star Runs', 'Future Spin', 'Mollie Mid-Wicket', 'Chart Climber King', 'Pop Princess Pace', 'Saturdays Slogger', 'King of Swing']
  },
  {
    id: 'dance-anthems',
    name: 'Dance Anthem XI',
    shortName: 'DAX',
    color: '#1ABC9C',
    // Radio 1's Dance Anthems with Charlie Hedges
    players: ['Charlie Edges', 'Floor Filler Fred', 'Beat Drop Bob', 'DJ Wicket', 'Club Classic Colin', 'Hedges\' Heave', 'Dance All-Rounder', 'Bass Drop Bowler', 'Weekend Warrior', 'Drop the Bat', 'Charlie\'s Charge']
  },
  {
    id: 'chillest-xi',
    name: 'Chillest XI',
    shortName: 'CHL',
    color: '#6B5B95',
    // Radio 1's Chillest Show with Sian Eleri
    players: ['Sian El-LBW-ri', 'Chill Spin Sian', 'Downtempo Dan', 'Slow Ball Sian', 'Mellow Mid-Off', 'Soothing Sweep', 'Relaxed Run Rate', 'Easy Pace Eleri', 'Calm Cover Drive', 'Zen Yorker', 'Lo-Fi Leg Spin']
  }
];

// Shot directions for realistic ball movement
const shotDirections = {
  cover: { angle: 45, name: 'cover drive' },
  midOff: { angle: 30, name: 'straight drive' },
  midOn: { angle: -30, name: 'on drive' },
  midWicket: { angle: -45, name: 'flick through midwicket' },
  squareLeg: { angle: -90, name: 'pull shot' },
  point: { angle: 90, name: 'cut shot' },
  thirdMan: { angle: 120, name: 'late cut' },
  fineLeg: { angle: -135, name: 'glance to fine leg' },
  longOn: { angle: -15, name: 'lofted drive' },
  longOff: { angle: 15, name: 'lofted cover drive' }
};

// Fielder positions with their coverage zones
const fielderPositions = {
  slip: { x: 58, y: 76, zone: [100, 150] },
  gully: { x: 70, y: 68, zone: [80, 110] },
  point: { x: 80, y: 50, zone: [70, 100] },
  cover: { x: 72, y: 32, zone: [30, 60] },
  midOff: { x: 60, y: 22, zone: [15, 40] },
  midOn: { x: 40, y: 22, zone: [-40, -15] },
  midWicket: { x: 28, y: 32, zone: [-60, -30] },
  squareLeg: { x: 20, y: 50, zone: [-100, -70] },
  fineLeg: { x: 35, y: 76, zone: [-150, -120] }
};

// ============================================
// SEEDED RANDOM (for sync across all viewers)
// ============================================

class SeededRNG {
  constructor(seed) {
    this.seed = seed;
  }

  next() {
    this.seed = (this.seed * 9301 + 49297) % 233280;
    return this.seed / 233280;
  }

  nextInt(min, max) {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  pick(array) {
    return array[this.nextInt(0, array.length - 1)];
  }

  nextFloat(min, max) {
    return min + this.next() * (max - min);
  }
}

// ============================================
// LEAGUE STATE
// ============================================

const MATCH_DURATION_MS = 20 * 60 * 1000; // 20 minutes
const LEAGUE_START = new Date('2026-02-18T18:26:00Z').getTime();
const OVERS_PER_INNINGS = 20;
const BALLS_PER_OVER = 6;

function getLeagueState() {
  const baseState = initializeLeague();

  // Calculate current season standings
  const { matchNumber } = getCurrentMatchInfo();
  const matchesPerSeason = baseState.fixtures.length; // 28 matches
  const currentSeason = Math.floor(matchNumber / matchesPerSeason) + 1;
  const matchInSeason = matchNumber % matchesPerSeason;

  // Reset table for current season calculation
  const table = teams.map(t => ({
    teamId: t.id,
    played: 0,
    won: 0,
    lost: 0,
    tied: 0,
    points: 0,
    runRate: 0,
    runsFor: 0,
    runsAgainst: 0
  }));

  // Simulate all completed matches in this season
  for (let m = 0; m < matchInSeason; m++) {
    const fixture = baseState.fixtures[m];
    const seed = (currentSeason - 1) * matchesPerSeason * 1000 + m * 1000 + currentSeason;
    const match = simulateMatch(fixture.homeTeam, fixture.awayTeam, seed);

    // Get final scores (away bats first, home bats second)
    const homeTeamEntry = table.find(t => t.teamId === fixture.homeTeam);
    const awayTeamEntry = table.find(t => t.teamId === fixture.awayTeam);
    const homeScore = match.secondInnings.runs;
    const awayScore = match.firstInnings.runs;

    if (homeTeamEntry && awayTeamEntry) {
      homeTeamEntry.played++;
      awayTeamEntry.played++;
      homeTeamEntry.runsFor += homeScore;
      homeTeamEntry.runsAgainst += awayScore;
      awayTeamEntry.runsFor += awayScore;
      awayTeamEntry.runsAgainst += homeScore;

      if (match.winner === fixture.homeTeam) {
        homeTeamEntry.won++;
        homeTeamEntry.points += 2;
        awayTeamEntry.lost++;
      } else if (match.winner === fixture.awayTeam) {
        awayTeamEntry.won++;
        awayTeamEntry.points += 2;
        homeTeamEntry.lost++;
      } else {
        homeTeamEntry.tied++;
        awayTeamEntry.tied++;
        homeTeamEntry.points += 1;
        awayTeamEntry.points += 1;
      }

      // Calculate net run rate
      if (homeTeamEntry.played > 0) {
        homeTeamEntry.runRate = ((homeTeamEntry.runsFor - homeTeamEntry.runsAgainst) / homeTeamEntry.played).toFixed(2);
      }
      if (awayTeamEntry.played > 0) {
        awayTeamEntry.runRate = ((awayTeamEntry.runsFor - awayTeamEntry.runsAgainst) / awayTeamEntry.played).toFixed(2);
      }
    }
  }

  return {
    ...baseState,
    table,
    season: currentSeason,
    matchIndex: matchInSeason
  };
}

function saveLeagueState(state) {
  localStorage.setItem('cricket-league-state', JSON.stringify(state));
}

function initializeLeague() {
  const fixtures = generateFixtures();
  const state = {
    season: 1,
    matchIndex: 0,
    fixtures: fixtures,
    table: teams.map(t => ({
      teamId: t.id,
      played: 0,
      won: 0,
      lost: 0,
      tied: 0,
      points: 0,
      runRate: 0,
      runsFor: 0,
      runsAgainst: 0
    })),
    completedMatches: []
  };
  saveLeagueState(state);
  return state;
}

function generateFixtures() {
  const fixtures = [];
  for (let i = 0; i < teams.length; i++) {
    for (let j = i + 1; j < teams.length; j++) {
      fixtures.push({
        homeTeam: teams[i].id,
        awayTeam: teams[j].id,
        completed: false,
        result: null
      });
    }
  }
  const rng = new SeededRNG(42);
  for (let i = fixtures.length - 1; i > 0; i--) {
    const j = rng.nextInt(0, i);
    [fixtures[i], fixtures[j]] = [fixtures[j], fixtures[i]];
  }
  return fixtures;
}

// ============================================
// REALISTIC MATCH SIMULATION
// ============================================

function getCurrentMatchInfo() {
  const now = Date.now();
  const elapsed = now - LEAGUE_START;
  const matchNumber = Math.floor(elapsed / MATCH_DURATION_MS);
  const matchProgress = (elapsed % MATCH_DURATION_MS) / MATCH_DURATION_MS;
  const timeIntoMatch = elapsed % MATCH_DURATION_MS;

  return {
    matchNumber,
    matchProgress,
    timeIntoMatch,
    timeRemaining: MATCH_DURATION_MS - timeIntoMatch
  };
}

function simulateMatch(homeTeamId, awayTeamId, seed) {
  const rng = new SeededRNG(seed);
  const homeTeam = teams.find(t => t.id === homeTeamId);
  const awayTeam = teams.find(t => t.id === awayTeamId);

  const firstInnings = simulateInnings(awayTeam, homeTeam, rng);
  const secondInnings = simulateInnings(homeTeam, awayTeam, rng, firstInnings.runs + 1);

  return {
    homeTeam: homeTeamId,
    awayTeam: awayTeamId,
    firstInnings,
    secondInnings,
    balls: [...firstInnings.balls.map(b => ({...b, innings: 1})),
            ...secondInnings.balls.map(b => ({...b, innings: 2}))],
    winner: secondInnings.runs > firstInnings.runs ? homeTeamId :
            secondInnings.runs < firstInnings.runs ? awayTeamId : null
  };
}

function simulateInnings(battingTeam, bowlingTeam, rng, target = null) {
  const balls = [];
  let runs = 0;
  let wickets = 0;
  let currentBatsman = 0;
  let nonStriker = 1;
  let currentBowler = 0;
  let partnershipRuns = 0;
  let batsmanRuns = {};
  batsmanRuns[0] = 0;
  batsmanRuns[1] = 0;

  for (let over = 0; over < OVERS_PER_INNINGS && wickets < 10; over++) {
    // Rotate bowlers realistically
    const bowlerPool = [5, 6, 7, 8, 9, 10];
    currentBowler = bowlerPool[over % bowlerPool.length];

    for (let ball = 0; ball < BALLS_PER_OVER && wickets < 10; ball++) {
      const gameState = {
        runs, wickets, over, ball, target,
        runRate: over > 0 ? runs / over : 0,
        requiredRate: target && over < OVERS_PER_INNINGS ?
          (target - runs) / (OVERS_PER_INNINGS - over) : 0,
        partnershipRuns,
        batsmanRuns: batsmanRuns[currentBatsman] || 0
      };

      const result = simulateBall(rng, gameState, battingTeam, bowlingTeam);

      // Determine shot direction and fielder involved
      const shotDir = result.shotDirection || 'cover';
      const fielder = result.fielder || null;

      balls.push({
        over,
        ball,
        batsman: battingTeam.players[currentBatsman],
        batsmanIndex: currentBatsman,
        nonStriker: battingTeam.players[nonStriker],
        bowler: bowlingTeam.players[currentBowler],
        result: result.type,
        runs: result.runs,
        totalRuns: runs + result.runs,
        totalWickets: wickets + (result.type === 'WICKET' ? 1 : 0),
        commentary: result.commentary,
        shotDirection: shotDir,
        shotAngle: shotDirections[shotDir]?.angle || 0,
        fielder: fielder,
        ballSpeed: result.ballSpeed || 'normal',
        isEdge: result.isEdge || false
      });

      runs += result.runs;
      partnershipRuns += result.runs;
      if (batsmanRuns[currentBatsman] !== undefined) {
        batsmanRuns[currentBatsman] += result.runs;
      }

      // Handle wicket
      if (result.type === 'WICKET') {
        wickets++;
        currentBatsman = wickets + 1;
        partnershipRuns = 0;
        if (currentBatsman <= 10) {
          batsmanRuns[currentBatsman] = 0;
        }
      }

      // Swap batsmen for odd runs
      if (result.runs % 2 === 1) {
        [currentBatsman, nonStriker] = [nonStriker, currentBatsman];
      }

      if (target && runs >= target) break;
    }

    // Swap batsmen at end of over
    [currentBatsman, nonStriker] = [nonStriker, currentBatsman];

    if (target && runs >= target) break;
  }

  return { runs, wickets, balls, overs: balls.length / BALLS_PER_OVER };
}

function simulateBall(rng, gameState, battingTeam, bowlingTeam) {
  const { runs, wickets, over, target, runRate, requiredRate, batsmanRuns } = gameState;

  // Base probabilities (realistic T20 cricket)
  let wicketChance = 0.04;    // ~4% per ball
  let dotChance = 0.35;        // ~35% dots
  let singleChance = 0.30;     // ~30% singles
  let twoChance = 0.10;        // ~10% twos
  let threeChance = 0.02;      // ~2% threes
  let fourChance = 0.12;       // ~12% fours
  let sixChance = 0.07;        // ~7% sixes

  // Adjust for game situation
  // Powerplay (overs 0-5): more boundaries, fewer dots
  if (over < 6) {
    fourChance += 0.03;
    sixChance += 0.02;
    dotChance -= 0.05;
  }

  // Death overs (16-20): more risk, more reward
  if (over >= 16) {
    sixChance += 0.05;
    fourChance += 0.03;
    wicketChance += 0.02;
    dotChance -= 0.05;
  }

  // Chasing pressure
  if (target) {
    if (requiredRate > 10) {
      sixChance += 0.05;
      wicketChance += 0.03;
    } else if (requiredRate < 6) {
      dotChance += 0.05;
      singleChance += 0.05;
      sixChance -= 0.03;
    }
  }

  // New batsman plays carefully
  if (batsmanRuns < 10) {
    dotChance += 0.10;
    sixChance -= 0.03;
    singleChance += 0.05;
  }

  const rand = rng.next();
  let cumulative = 0;

  // Wicket
  cumulative += wicketChance;
  if (rand < cumulative) {
    return generateWicket(rng, bowlingTeam);
  }

  // Six
  cumulative += sixChance;
  if (rand < cumulative) {
    return generateSix(rng);
  }

  // Four
  cumulative += fourChance;
  if (rand < cumulative) {
    return generateFour(rng);
  }

  // Three
  cumulative += threeChance;
  if (rand < cumulative) {
    return generateRuns(rng, 3);
  }

  // Two
  cumulative += twoChance;
  if (rand < cumulative) {
    return generateRuns(rng, 2);
  }

  // Single
  cumulative += singleChance;
  if (rand < cumulative) {
    return generateRuns(rng, 1);
  }

  // Dot ball
  return generateDot(rng);
}

function generateWicket(rng, bowlingTeam) {
  const dismissalTypes = [
    { type: 'bowled', weight: 20, commentary: (b) => `BOWLED HIM! ${b} knocks back the stumps!` },
    { type: 'caught', weight: 35, commentary: (b, f) => `CAUGHT! Taken by ${f}!` },
    { type: 'lbw', weight: 20, commentary: (b) => `LBW! Plumb in front, umpire raises the finger!` },
    { type: 'caught & bowled', weight: 10, commentary: (b) => `CAUGHT & BOWLED! ${b} takes a sharp return catch!` },
    { type: 'stumped', weight: 8, commentary: () => `STUMPED! Quick work from the keeper!` },
    { type: 'run out', weight: 7, commentary: (b, f) => `RUN OUT! Direct hit from ${f}!` }
  ];

  const totalWeight = dismissalTypes.reduce((sum, d) => sum + d.weight, 0);
  let rand = rng.next() * totalWeight;

  let dismissal = dismissalTypes[0];
  for (const d of dismissalTypes) {
    rand -= d.weight;
    if (rand <= 0) {
      dismissal = d;
      break;
    }
  }

  const fielders = ['slip', 'point', 'cover', 'midOff', 'midOn', 'midWicket', 'squareLeg', 'fineLeg'];
  const fielder = rng.pick(fielders);
  const bowler = bowlingTeam.players[rng.nextInt(5, 10)];

  return {
    type: 'WICKET',
    runs: 0,
    commentary: dismissal.commentary(bowler, fielder),
    shotDirection: fielder,
    fielder: fielder,
    dismissalType: dismissal.type
  };
}

function generateSix(rng) {
  const shots = [
    { dir: 'longOn', commentary: 'SIX! Launched over long on!' },
    { dir: 'longOff', commentary: 'SIX! Huge hit over long off!' },
    { dir: 'midWicket', commentary: 'SIX! Deposited into the stands at midwicket!' },
    { dir: 'cover', commentary: 'SIX! Inside out over cover, magnificent!' },
    { dir: 'squareLeg', commentary: 'SIX! Pulled high into the crowd!' }
  ];
  const shot = rng.pick(shots);
  return {
    type: 'SIX',
    runs: 6,
    commentary: shot.commentary,
    shotDirection: shot.dir,
    ballSpeed: 'fast'
  };
}

function generateFour(rng) {
  const shots = [
    { dir: 'cover', commentary: 'FOUR! Lovely cover drive, bisects the field!' },
    { dir: 'point', commentary: 'FOUR! Cut away past point!' },
    { dir: 'midOff', commentary: 'FOUR! Driven straight past the bowler!' },
    { dir: 'midWicket', commentary: 'FOUR! Flicked through midwicket!' },
    { dir: 'squareLeg', commentary: 'FOUR! Pulled to the boundary!' },
    { dir: 'thirdMan', commentary: 'FOUR! Late cut, runs away to third man!' },
    { dir: 'fineLeg', commentary: 'FOUR! Glanced fine, beats the fielder!' },
    { dir: 'gully', commentary: 'FOUR! Edged but safe, races to the boundary!' }
  ];
  const shot = rng.pick(shots);
  const isEdge = shot.dir === 'gully' || shot.dir === 'thirdMan';
  return {
    type: 'FOUR',
    runs: 4,
    commentary: shot.commentary,
    shotDirection: shot.dir,
    ballSpeed: 'fast',
    isEdge
  };
}

function generateRuns(rng, numRuns) {
  const directions = ['cover', 'midOff', 'midOn', 'midWicket', 'point', 'squareLeg'];
  const dir = rng.pick(directions);

  const commentary = {
    1: [
      `Pushed to ${dir}, quick single.`,
      `Nudged for one.`,
      `Sharp running, single taken.`,
      `Tucked away for a single.`
    ],
    2: [
      `Driven to ${dir}, well run two!`,
      `Good placement, they come back for two.`,
      `Worked into the gap, excellent running for two.`
    ],
    3: [
      `Driven into the gap, they've run THREE!`,
      `Misfield! Three runs as the batsmen push hard.`,
      `Big gap in the field, great running for three!`
    ]
  };

  return {
    type: 'RUNS',
    runs: numRuns,
    commentary: rng.pick(commentary[numRuns]),
    shotDirection: dir,
    ballSpeed: 'normal'
  };
}

function generateDot(rng) {
  const outcomes = [
    { dir: 'cover', commentary: 'Defended solidly to cover.' },
    { dir: 'point', commentary: 'Cut straight to point, no run.' },
    { dir: 'midOff', commentary: 'Driven to mid-off, good stop.' },
    { dir: 'midOn', commentary: 'Pushed back to the bowler, dot ball.' },
    { dir: 'keeper', commentary: 'Beaten! Good delivery, through to the keeper.' },
    { dir: 'keeper', commentary: 'Left alone outside off, wise decision.' },
    { dir: 'midWicket', commentary: 'Defended on the leg side, no run.' }
  ];
  const outcome = rng.pick(outcomes);
  return {
    type: 'DOT',
    runs: 0,
    commentary: outcome.commentary,
    shotDirection: outcome.dir,
    ballSpeed: 'normal'
  };
}

// ============================================
// GET CURRENT BALL (for live viewing)
// ============================================

function getCurrentMatchState() {
  const state = getLeagueState();
  const { matchNumber, matchProgress, timeIntoMatch, timeRemaining } = getCurrentMatchInfo();

  const currentFixtureIndex = matchNumber % state.fixtures.length;
  const currentSeason = Math.floor(matchNumber / state.fixtures.length) + 1;

  const fixture = state.fixtures[currentFixtureIndex];

  const seed = matchNumber * 1000 + currentSeason;
  const match = simulateMatch(fixture.homeTeam, fixture.awayTeam, seed);

  const totalBalls = match.balls.length;
  const currentBallIndex = Math.min(
    Math.floor(matchProgress * totalBalls),
    totalBalls - 1
  );

  const currentBall = match.balls[currentBallIndex];
  const isFirstInnings = currentBall.innings === 1;

  let firstInningsScore = { runs: 0, wickets: 0, overs: 0 };
  let secondInningsScore = { runs: 0, wickets: 0, overs: 0 };

  for (let i = 0; i <= currentBallIndex; i++) {
    const ball = match.balls[i];
    if (ball.innings === 1) {
      firstInningsScore.runs = ball.totalRuns;
      firstInningsScore.wickets = ball.totalWickets;
      firstInningsScore.overs = ball.over + (ball.ball + 1) / 6;
    } else {
      secondInningsScore.runs = ball.totalRuns;
      secondInningsScore.wickets = ball.totalWickets;
      secondInningsScore.overs = ball.over + (ball.ball + 1) / 6;
    }
  }

  const homeTeam = teams.find(t => t.id === fixture.homeTeam);
  const awayTeam = teams.find(t => t.id === fixture.awayTeam);

  const recentBalls = match.balls.slice(Math.max(0, currentBallIndex - 5), currentBallIndex + 1);

  return {
    matchNumber,
    season: currentSeason,
    fixtureIndex: currentFixtureIndex,
    homeTeam,
    awayTeam,
    isFirstInnings,
    battingTeam: isFirstInnings ? awayTeam : homeTeam,
    bowlingTeam: isFirstInnings ? homeTeam : awayTeam,
    firstInningsScore,
    secondInningsScore,
    currentBall,
    recentBalls,
    target: isFirstInnings ? null : firstInningsScore.runs + 1,
    matchProgress,
    timeRemaining,
    isMatchComplete: currentBallIndex >= totalBalls - 1,
    matchResult: match.winner ? teams.find(t => t.id === match.winner) : null,
    table: state.table,
    fielderPositions
  };
}

function formatOvers(overs) {
  const fullOvers = Math.floor(overs);
  const balls = Math.round((overs - fullOvers) * 6);
  return `${fullOvers}.${balls}`;
}

function getTeamById(id) {
  return teams.find(t => t.id === id);
}

// ============================================
// LEAGUE STATS & RECORDS
// ============================================

function getLeagueStats() {
  const { matchNumber } = getCurrentMatchInfo();
  const totalMatches = matchNumber + 1;
  const totalSeasons = Math.floor(matchNumber / 28) + 1; // 28 matches per season (8 teams, each plays 7)

  // Time since league started
  const now = Date.now();
  const elapsed = now - LEAGUE_START;
  const days = Math.floor(elapsed / (1000 * 60 * 60 * 24));
  const hours = Math.floor((elapsed % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));

  // Calculate all-time records by simulating historical matches
  const records = calculateAllTimeRecords(matchNumber);

  return {
    totalMatches,
    totalSeasons,
    leagueAge: { days, hours, minutes },
    totalBallsBowled: totalMatches * 240, // Approx 240 balls per match
    estimatedRuns: totalMatches * 320, // Approx 320 runs per match
    estimatedWickets: totalMatches * 14, // Approx 14 wickets per match
    estimatedSixes: totalMatches * 28, // Approx 28 sixes per match
    estimatedFours: totalMatches * 48, // Approx 48 fours per match
    ...records
  };
}

function calculateAllTimeRecords(upToMatch) {
  // Sample a subset of matches to find records (for performance)
  const sampleSize = Math.min(upToMatch, 50);
  const sampleStep = Math.max(1, Math.floor(upToMatch / sampleSize));

  let topBatters = {};
  let topBowlers = {};
  let highestScore = { runs: 0, player: '', team: '', match: 0 };
  let bestBowling = { wickets: 0, player: '', team: '', match: 0 };
  let mostSixes = { count: 0, player: '', team: '' };
  let mostFours = { count: 0, player: '', team: '' };

  const state = getLeagueState();

  for (let m = 0; m < upToMatch; m += sampleStep) {
    const fixtureIndex = m % state.fixtures.length;
    const season = Math.floor(m / state.fixtures.length) + 1;
    const fixture = state.fixtures[fixtureIndex];
    const seed = m * 1000 + season;

    // Simulate match
    const rng = new SeededRNG(seed);
    const homeTeam = teams.find(t => t.id === fixture.homeTeam);
    const awayTeam = teams.find(t => t.id === fixture.awayTeam);

    // Track batting performances
    const batsmen = {};
    const bowlers = {};
    const sixHitters = {};
    const fourHitters = {};

    // Simple simulation for stats
    for (let innings = 0; innings < 2; innings++) {
      const battingTeam = innings === 0 ? awayTeam : homeTeam;
      const bowlingTeam = innings === 0 ? homeTeam : awayTeam;
      let currentBatsman = 0;
      let batsmanRuns = 0;
      let batsmanSixes = 0;
      let batsmanFours = 0;

      for (let ball = 0; ball < 120; ball++) { // 20 overs
        const rand = rng.next();
        let runs = 0;
        let isWicket = false;
        let isSix = false;
        let isFour = false;

        if (rand < 0.04) {
          isWicket = true;
          // Track bowler wicket
          const bowlerIdx = Math.floor(ball / 6) % 6;
          const bowlerName = bowlingTeam.players[5 + bowlerIdx];
          bowlers[bowlerName] = (bowlers[bowlerName] || 0) + 1;
        } else if (rand < 0.11) {
          runs = 6;
          isSix = true;
        } else if (rand < 0.23) {
          runs = 4;
          isFour = true;
        } else if (rand < 0.35) {
          runs = 1;
        } else if (rand < 0.45) {
          runs = 2;
        }

        batsmanRuns += runs;
        if (isSix) batsmanSixes++;
        if (isFour) batsmanFours++;

        if (isWicket) {
          const playerName = battingTeam.players[currentBatsman];
          batsmen[playerName] = (batsmen[playerName] || 0) + batsmanRuns;
          sixHitters[playerName] = (sixHitters[playerName] || 0) + batsmanSixes;
          fourHitters[playerName] = (fourHitters[playerName] || 0) + batsmanFours;

          if (batsmanRuns > highestScore.runs) {
            highestScore = { runs: batsmanRuns, player: playerName, team: battingTeam.shortName, match: m };
          }

          currentBatsman++;
          batsmanRuns = 0;
          batsmanSixes = 0;
          batsmanFours = 0;
          if (currentBatsman >= 10) break;
        }
      }

      // Final batsman
      if (currentBatsman < 10) {
        const playerName = battingTeam.players[currentBatsman];
        batsmen[playerName] = (batsmen[playerName] || 0) + batsmanRuns;
        sixHitters[playerName] = (sixHitters[playerName] || 0) + batsmanSixes;
        fourHitters[playerName] = (fourHitters[playerName] || 0) + batsmanFours;

        if (batsmanRuns > highestScore.runs) {
          highestScore = { runs: batsmanRuns, player: playerName, team: battingTeam.shortName, match: m };
        }
      }
    }

    // Aggregate to top lists
    for (const [player, runs] of Object.entries(batsmen)) {
      topBatters[player] = (topBatters[player] || 0) + runs;
    }
    for (const [player, wickets] of Object.entries(bowlers)) {
      topBowlers[player] = (topBowlers[player] || 0) + wickets;
      if (wickets > bestBowling.wickets) {
        const team = teams.find(t => t.players.includes(player));
        bestBowling = { wickets, player, team: team?.shortName || '???', match: m };
      }
    }
    for (const [player, sixes] of Object.entries(sixHitters)) {
      if (!mostSixes.player || sixes > (sixHitters[mostSixes.player] || 0)) {
        const team = teams.find(t => t.players.includes(player));
        mostSixes = { count: sixes, player, team: team?.shortName || '???' };
      }
    }
    for (const [player, fours] of Object.entries(fourHitters)) {
      if (!mostFours.player || fours > (fourHitters[mostFours.player] || 0)) {
        const team = teams.find(t => t.players.includes(player));
        mostFours = { count: fours, player, team: team?.shortName || '???' };
      }
    }
  }

  // Sort and get top 5
  const sortedBatters = Object.entries(topBatters).sort((a, b) => b[1] - a[1]).slice(0, 5);
  const sortedBowlers = Object.entries(topBowlers).sort((a, b) => b[1] - a[1]).slice(0, 5);

  return {
    topBatters: sortedBatters.map(([name, runs]) => {
      const team = teams.find(t => t.players.includes(name));
      return { name, runs, team: team?.shortName || '???' };
    }),
    topBowlers: sortedBowlers.map(([name, wickets]) => {
      const team = teams.find(t => t.players.includes(name));
      return { name, wickets, team: team?.shortName || '???' };
    }),
    highestScore,
    bestBowling,
    mostSixes,
    mostFours
  };
}

// ============================================
// EXPORTS
// ============================================

export {
  teams,
  getCurrentMatchState,
  getLeagueState,
  getLeagueStats,
  formatOvers,
  getTeamById,
  MATCH_DURATION_MS,
  LEAGUE_START,
  fielderPositions,
  shotDirections
};
